module.exports = __webpack_public_path__ + "static/media/40.1f986438.jpg";